import { render, staticRenderFns } from "./o-tile.vue?vue&type=template&id=27b38a8c&scoped=true"
import script from "./o-tile.js?vue&type=script&lang=js&external"
export * from "./o-tile.js?vue&type=script&lang=js&external"
import style0 from "./o-tile.scss?vue&type=style&index=0&id=27b38a8c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b38a8c",
  null
  
)

export default component.exports